import { gql } from '@apollo/client';

const GET_EXPENSE_MILEAGE_TOTAL = gql`
query calculateExpenseMileageTotal ($mileage: Decimal!, $mileageTypeId: Int!, $ytdMileage: Decimal!, $referenceDate: DateTime!) {
  calculateExpenseMileageTotal (mileage: $mileage, mileageTypeId: $mileageTypeId, ytdMileage: $ytdMileage, referenceDate: $referenceDate) 
}`;

export default GET_EXPENSE_MILEAGE_TOTAL;